﻿import type { ReactNode } from "react";
import { TreeItem, TreeItemProps } from "@mui/x-tree-view-pro";

interface ConditionalTreeItemProps extends TreeItemProps {
    show: boolean;
}

function ConditionalTreeItem(props: ConditionalTreeItemProps) {
    const { show, children, ...rest } = props;

    return show ? <TreeItem {...rest}>{children}</TreeItem> : children as ReactNode;
}

export { ConditionalTreeItem };